/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureDisk } from '../models/AzureDisk';

/**
* Properties of the original Azure Virtual Machine instance at the time the snapshot was taken. Present only when `resourceType` is set to `AZURE_VIRTUAL_MACHINE`. 
*/
export class AzureVmSnapshotProperties {
  /**
  * VM name.
  */
  'name'?: string;
  /**
  * VM size, in bytes.
  */
  'sizeBytes'?: string;
  /**
  * List of disks attached to the resource.
  */
  'disks'?: Array<AzureDisk>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "string",
      "format": ""
    },
    {
      "name": "disks",
      "baseName": "disks",
      "type": "Array<AzureDisk>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureVmSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

